export enum ExpensesMutations {
  RESET = "RESET",
  SET_EXPENSES = "SET_EXPENSES",
}
